import { useMemo } from 'react';
import { AUTOCOMPLETE_SEARCH_TRIGGER_DEFAULT_MIN_LENGTH } from '../../../constants';

export function useIsSearchQueryReachedMinimumLengthThreshold(
  debouncedSearchQuery?: string,
  searchTriggerMinLength?: number
) {
  return useMemo(() => {
    return (
      (debouncedSearchQuery?.length ?? 0) >=
      (searchTriggerMinLength ?? AUTOCOMPLETE_SEARCH_TRIGGER_DEFAULT_MIN_LENGTH)
    );
  }, [debouncedSearchQuery, searchTriggerMinLength]);
}
